import {
  Component,
  OnInit,
  Inject,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { DataService, Response } from "../dataService/data.service";
import { GlobalVariable } from "../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { CommonService } from "../services/common.service";
import { ChangeDetectionStrategy } from "@angular/compiler/src/core";

@Component({
  selector: "app-review-experience-layout",
  templateUrl: "./review-experience-layout.component.html",
  styleUrls: ["./review-experience-layout.component.scss"],
})
export class ReviewExperienceLayoutComponent implements OnInit {
  private BASE_URL = GlobalVariable;
  slug_value: string;
  feed_back: boolean;
  review_status: boolean;
  url_auto_redirect: boolean;
  auto_redirect: string;
  show_module: boolean = false;
  show_page: String = "NO";
  isApiError: boolean = false;
  is_ai_review_enabled: boolean = false;
  // Covers the gap between page load and the child component rendering, and stays
  // up through the redirect when the rating step is skipped.
  loading: boolean = true;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    private route: ActivatedRoute,
    private commonservice: CommonService,
    private router: Router
  ) {}

  ngOnInit() {
    this.commonservice.commonData.subscribe((data: any) => {
      if (data !== null) {
        if (data?.isApiError) {
          this.isApiError = true;
          this.loading = false;
        } else {
          if (this.show_page === "NO") {
            this.feed_back = data["review_click_steps"] === 1 ? true : false;
            this.review_status = data["review_status"];
            this.storage.set("auto_redirect", data.auto_redirect);
            this.show_module = true;
            this.is_ai_review_enabled = data["is_ai_review_enabled"] || false;
            if (this.is_ai_review_enabled) {
              // Keep the loader up across the navigation to avoid a blank frame.
              this.router.navigate(['/ai-review', this.slug_value]);
              return;
            }

            // The WhatsApp flow already captured a positive rating: render the
            // platform list directly so its existing auto-redirect kicks in,
            // instead of asking for the rating again.
            const skipFeedbackStep = data["skip_feedback_step"] === true;
            this.commonservice.skip_feedback_step.next(skipFeedbackStep);
            if (skipFeedbackStep) {
              this.feed_back = true;
              // Child owns the loader from here until it redirects.
              return;
            }

            this.loading = false;
          } else {
            this.loading = false;
          }
        }
      }
    });

    this.commonservice.show_review_page.subscribe((show_page) => {
      this.show_page = show_page;
      if (this.show_page === "YES") {
        // console.log("yes");
        this.feed_back = true;
        this.show_module = true;
        this.review_status = false;
        this.loading = false;
        // this.ref.detectChanges();
      } else {
        // let res: Response;
        this.route.params.forEach((val) => {
          this.slug_value = val["id"];
        });
        this.commonservice.getCommonData(this.slug_value);
      }
    });
  }
}
